class Organization {
    constructor(request) {
        this.request = request;
        this.endpoint = "organization"
    }

	Search(category, fail ) {
		return this.request.requestData(`https://cdn.ngnw.ph/lists/${this.endpoint}/category/${category}.json`)
	}

    SearchText = (searchText) => {
        const body = {
            "searchtext": searchText
        }

        return this.request.send(
            `search/${this.endpoint}/`,
            'POST',
            body
        )
    }
}

export default Organization;